import { useState } from 'react';
import DataGrid, { Column } from 'devextreme-react/data-grid';
import { InformModal } from '../../../common/SharedComponents';
import { getFileStatusColumnHtml } from '../../common/ApplicationFunctions';
import { ApplActionsButton } from '../../common/ApplicationComponents';
import { onCellDblClickReview } from '../../common/ApplicationFunctions';

const PortfolioTable = ({ data, isRental = false, isBridge = false }) => {
    const [informModalOpen, set_informModalOpen] = useState(false);

    const actionCellRender = (e) => {
        return (
            <ApplActionsButton
                data={e.data}
                isPropertyLevel={true}
            />
        );
    };

    const onAddressCellRender = (e) => {
        if (e.data.address.street2) {
            return e.data.address.street1 + ', ' + e.data.address.street2;
        } else {
            return e.data.address.street1;
        }
    };

    const onFileStatusCellRender = (e) => {
        return getFileStatusColumnHtml(e.value);
    };

    if (!data || data.length === 0) {
        return '';
    }

    return (
        <div style={{ padding: '5px 20px' }}>
            <DataGrid
                dataSource={data}
                showBorders={true}
                showRowLines={false}
                rowAlternationEnabled={true}
                remoteOperations={false}
                allowColumnReordering={false}
                allowColumnResizing={true}
                width={'80%'}
                cellHintEnabled={true}
                onCellDblClick={onCellDblClickReview}
            >
                <Column
                    dataField='address.street1'
                    caption='Address'
                    cellRender={onAddressCellRender}
                />
                <Column
                    dataField='address.city'
                    caption='City'
                    width={150}
                />
                <Column
                    dataField='address.state'
                    caption='State'
                    width={70}
                />
                <Column
                    dataField='address.zipCode'
                    caption='Zip'
                    width={70}
                />
                <Column
                    dataField='bfiNumber'
                    caption='BFI #'
                    dataType='string'
                    width={100}
                />
                <Column
                    dataField='fileStatusBudget'
                    caption='Budget'
                    width={70}
                    cellRender={(e) => getFileStatusColumnHtml(e.value, isBridge)}
                    alignment='center'
                    visible={!isRental}
                />
                <Column
                    dataField='fileStatusSpecSheet'
                    caption='Specs'
                    width={70}
                    cellRender={(e) => getFileStatusColumnHtml(e.value, isBridge)}
                    alignment='center'
                    visible={!isRental}
                />
                <Column
                    dataField='fileStatusPlans'
                    caption='Plan'
                    width={70}
                    cellRender={(e) => getFileStatusColumnHtml(e.value, isBridge)}
                    alignment='center'
                    visible={!isRental}
                />
                <Column
                    dataField='fileStatusSurvey'
                    caption='Survey'
                    width={70}
                    cellRender={onFileStatusCellRender}
                    alignment='center'
                    visible={!isRental}
                />
                <Column
                    alignment='center'
                    cellRender={actionCellRender}
                    width={50}
                    allowReordering={false}
                    allowSorting={false}
                    allowResizing={false}
                    type='actions'
                    fixed={true}
                    fixedPosition={'right'}
                />
            </DataGrid>
            <InformModal
                isOpen={informModalOpen}
                text={'No actions available for the selected property'}
                confirmCallback={() => set_informModalOpen(false)}
            />
        </div>
    );
};

export default PortfolioTable;
